import * as React from "react";
import {
  Text,
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { modifyPartner } from "../redux/actions/PartnerActions";
import GlobalStyles from "../components/GlobalStyles";
import axios from "axios";
import { user_force_refresh } from "../redux/actions/UserActions";

export default function NotificationUnlinkScreen({ route }) {
  const navigation = useNavigation();
  const BGimage = require("../assets/res/blue_bg.png");
  const sparkle = require("../assets/res/sparkle.png");
  const message = route.params.message;
  const values = route.params;
  const mypartnername = values.partnerName;
  const mypartnerID = values.partnerID;

  //modifyPartner(partner_name, 2, apiData);
  modifyPartner(mypartnername, 2, mypartnerID);
  user_force_refresh();

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={styles.modalContainerF}>
        <View style={styles.modalContainer}>
          <View>
            <View style={GlobalStyles.headerTextP}>
              <View style={GlobalStyles.headingStyle}>
              <View style={styles.PopupHeader}>
                <Text style={styles.textStyleHeader}>Done!</Text>
                <Text style={styles.textStyleHeader}></Text>
                </View>
                <View>
                <TouchableOpacity
                  style={styles.SubmitButtonStyle}
                  activeOpacity={0.5}
                  //onPress={() => navigation.navigate("MainMenu")}
                  onPress={() => navigation.popToTop()}
                >
                  <Text style={styles.textStyle}>CONTINUE</Text>
                </TouchableOpacity>
              </View>
            </View>
            </View>
          </View>
        </View>
        <View>
          <Image style={styles.sparkle} source={sparkle} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({

PopupHeader: {
paddingBottom: 30,
  },

  modalContainer: {
    height: 190,
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 70,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    marginLeft: 15,
    marginRight: 15,
    paddingTop: 55,
  },
  modalContainerF: {
    marginTop: 190,
    paddingTop: 55,
    marginLeft: 15,
    marginRight: 15,
  },
  SubmitButtonStyle: {
    paddingTop: 20,
    paddingBottom: 25,
    borderRadius: 50,
    backgroundColor: "#FFFFFF",
    //marginTop: 20,
    marginLeft: -15,
    paddingLeft:20,
    paddingRight:20,
    height: 60,
    justifyContent: 'center',
  },

  textStyleHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginLeft: -15,
  },

  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },

  sparkle: {
    position: "absolute",
    top: -205,
    right: -5,
    width: 40,
    height: 40,
  },
});
